/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'layout-three-columns': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M0 1.5A1.5 1.5 0 011.5 0h13A1.5 1.5 0 0116 1.5v13a1.5 1.5 0 01-1.5 1.5h-13A1.5 1.5 0 010 14.5zM1.5 1a.5.5 0 00-.5.5v13a.5.5 0 00.5.5H5V1zM10 15V1H6v14zm1 0h3.5a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5H11z"/>',
    },
});
